import { itx } from "../../translationItx/itx";
import Cabinet from "../../models/Cabinet";
import { SequenceStep, enumActions } from "../Guide";
import { ToDoItem } from "../ToDoItem";
import guideSequence_addCabinet from "./guideSequence_addCabinet";

// ContextMenuLables.addFloors
function sequence(type: string, lastToDoItem?: ToDoItem): Array<SequenceStep> {
  return [
    {
      action: enumActions.call,
      subSequence: () => {
        if (state.cabinets.size == 0) {
          return [
            {
              action: enumActions.explain,
              text: itx("onBoardingSequences.createFirstCabinet"), // itx("onBoardingSequences.tagNewRoom", "N1"),
            },
            ...guideSequence_addCabinet(""),
          ];
        } else {
          return [];
        }
      },
    },
    {
      action: enumActions.function,
      func: async (): Promise<void> => {
        state.selectionManager.selectedObject = state.cabinets.sortBy("tag")[0];
      },
    },
    {
      action: enumActions.wait,
    },
    {
      action: enumActions.focus,
      id: () => {
        return `tv-${state.cabinets.sortBy("tag")[0].id}`;
      },
    },
    {
      action: enumActions.click,
      id: () => {
        return [`tv-${state.cabinets.sortBy("tag")[0].id}`, `inlineButton_addActorOrELCB`];
      },
    },
    {
      action: enumActions.clickContextMenuItem,
      index: type == "Actor" ? 1 : type == "ELCB" ? 3 : 5,
    },
    // {
    //   action: enumActions.explain,
    //   text: itx("onBoardingSequences.T1Created").replace("T1", itx(`components.${type}`)),
    // },
    {
      action: enumActions.wait,
    },
    {
      action: enumActions.call,
      subSequence: () => {
        const actor = state.lastCreatedObjectForGuide;
        const cabinet = actor?.parent as Cabinet;
        let choosenName = "Aktor 1"; // no itx
        let allPossibleNameTag = [
          itx("channelType.Dimmer") + " " + itx("components.Actor"),
          itx("channelType.Switch") + " " + itx("components.Actor"),
          itx("channelType.Blind") + " " + itx("components.Actor"),
          itx("channelType.Heating") + " " + itx("components.Actor"),
          itx("channelType.Jalousie") + " " + itx("components.Actor"),
        ];
        allPossibleNameTag.forEach((possibility) => {
          let allreadyInProject = false;
          cabinet?.actors?.forEach((actor1) => {
            if (actor1.name == possibility) allreadyInProject = true;
          });
          if (!allreadyInProject && choosenName == "Aktor 1") {
            choosenName = possibility;
          }
        });
        if (actor?.className == "Actor") {
          return [
            // {
            //   action: enumActions.explain,
            //   id: "TabGeneralDevice_Name",
            //   text: "Hier kannst du den Namen des Aktors bestimmen",
            // },
            {
              action: enumActions.click,
              id: "TabGeneralDevice_Name",
            },
            {
              id: `TabGeneralDevice_Name`,
              action: enumActions.type,
              text: choosenName, // itx("onBoardingSequences.nameNewRoom", "Ein Neuer Raum"),
            },
          ];
        } else {
          return [];
        }
      },
    },
  ];
}

export default sequence;
